"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CIVIC_CATEGORICAL_COLORS = {
  civicBlue: [30, 98, 189],
  civicGreen: [25, 183, 170],
  civicPurple: [114, 29, 124],
  civicPink: [220, 69, 86],
  civicYellow: [255, 178, 38]
};
var CIVIC_SEQUENTIAL_COLORS = {
  thermal: [[255, 255, 204], [255, 237, 160], [254, 217, 118], [254, 178, 76], [253, 141, 60], [252, 78, 42], [227, 26, 28], [189, 0, 38], [128, 0, 38]],
  planet: [[247, 244, 249], [231, 225, 239], [212, 185, 218], [201, 148, 199], [223, 101, 176], [231, 41, 138], [206, 18, 86], [152, 0, 67], [103, 0, 31]],
  space: [[247, 252, 253], [224, 236, 244], [191, 211, 230], [158, 188, 218], [140, 150, 198], [140, 107, 177], [136, 65, 157], [129, 15, 124], [77, 0, 75]],
  earth: [[255, 247, 251], [236, 226, 240], [208, 209, 230], [166, 189, 219], [103, 169, 207], [54, 144, 192], [2, 129, 138], [1, 108, 89], [1, 70, 54]],
  ocean: [[255, 255, 217], [237, 248, 177], [199, 233, 180], [127, 205, 187], [65, 182, 196], [29, 145, 192], [34, 94, 168], [37, 52, 148], [8, 29, 88]]
};
var CIVIC_DIVERGING_COLORS = {
  purpleGreen: [[118, 42, 131], [153, 112, 171], [194, 165, 207], [231, 212, 232], [247, 247, 247], [217, 240, 211], [166, 219, 160], [90, 174, 97], [27, 120, 55]],
  purpleOrange: [[179, 88, 6], [224, 130, 20], [253, 184, 99], [254, 224, 182], [247, 247, 247], [216, 218, 235], [178, 171, 210], [128, 115, 172], [84, 39, 136]]
};

var CIVIC_MAP_COLORS = _objectSpread({}, CIVIC_CATEGORICAL_COLORS, CIVIC_SEQUENTIAL_COLORS, CIVIC_DIVERGING_COLORS);

var _default = CIVIC_MAP_COLORS;
exports["default"] = _default;